import { render, staticRenderFns } from "./AddCompanyAssociatePartner.vue?vue&type=template&id=4fd70d14"
import script from "./AddCompanyAssociatePartner.vue?vue&type=script&lang=js"
export * from "./AddCompanyAssociatePartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports